import { Stack, styled, Typography } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  gap: theme.spacing(1),
}));

export const StyledTitleBase = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  fontWeight: 500,
  lineHeight: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
    lineHeight: theme.spacing(4),
  },
}));

export const StyledTitle = (props: ComponentProps<typeof StyledTitleBase>) => (
  <StyledTitleBase variant="h1" {...props} />
);

export const StyledDescription = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 400,
  lineHeight: theme.spacing(3),
}));
